export default __webpack_public_path__ + "1e23c00c45ceab115f7ad8fd0044aba3.png";